module.exports = __webpack_public_path__ + "cfbc46cd73b3f2d8166711c607d4fc29.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/table/bill.png
// module id = 740
// module chunks = 0